/* eslint-disable */
// import Autoplay from 'embla-carousel-autoplay'
import { useEffect, useRef, useState } from 'react'
import left_chevron from '../../assets/Auth/chevron_backward.svg'
import right_chevron from '../../assets/Auth/chevron_forward.svg'
import { useThemeMode } from '../../Provider/ThemeContextProvider'
import { cn } from '../../lib/utils'

const AUTO_PLAY_INTERVAL_MS = 3000

const slides = [
  {
    graphic: 'goals',
    subtitle: 'Build wealth for financial milestones of your life',
    subtext:
      'From your next vacation to your retirement - build a corpus for all your financial obligations',
  },
  {
    graphic: 'portfolio',
    subtitle: 'Plan, invest in & track all your goals in one place',
    subtext: 'No more shuffling between spreadsheets & your demat accounts',
  },
  {
    graphic: 'advisor',
    subtitle: 'Get Professional Expertise for your Personal Finance',
    subtext: 'Create wealth with personalised strategies built by professionals',
  },
]

const useAutoPlayCarousel = () => {
  const [currentSlide, setCurrentSlide] = useState(0)

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % slides.length)
  }

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + slides.length) % slides.length)
  }

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length)
    }, AUTO_PLAY_INTERVAL_MS)

    return () => clearInterval(timer)
  }, [])

  return { currentSlide, setCurrentSlide, nextSlide, prevSlide }
}

export const darkGridStyle = {
  backgroundImage:
    'linear-gradient(to right, rgba(255, 255, 255, 0.05) 1px, transparent 1px), linear-gradient(to bottom, rgba(255, 255, 255, 0.05) 1px, transparent 1px)',
  backgroundSize: '48px 48px',
}

export const lightGridStyle = {
  backgroundImage:
    'linear-gradient(to right, rgba(4, 3, 19, 0.06) 1px, transparent 1px), linear-gradient(to bottom, rgba(4, 3, 19, 0.06) 1px, transparent 1px)',
  backgroundSize: '48px 48px',
}

const SvgOnlyGraphic = ({ src, scale = 'scale-[1.52]' }) => (
  <img
    src={src}
    alt=''
    className={`absolute left-1/2 top-1/2 h-full w-full -translate-x-1/2 -translate-y-1/2 object-contain ${scale}`}
  />
)

const MilestoneGraphic = () => (
  <SvgOnlyGraphic src='/Auth/login-life-ledger-calendar.svg' scale='scale-[1.7]' />
)

const PortfolioGraphic = ({ compact = false }) => (
  <SvgOnlyGraphic
    src='/Auth/login-one-place-stack.svg'
    scale={compact ? 'scale-[1.5]' : 'scale-[1.66]'}
  />
)

const AdvisorGraphic = () => (
  <SvgOnlyGraphic src='/Auth/login-private-strategy-puzzle.svg' scale='scale-[1.62]' />
)

const graphicComponents = {
  goals: MilestoneGraphic,
  portfolio: PortfolioGraphic,
  advisor: AdvisorGraphic,
}

const EditorialGraphic = ({ slide, compact = false }) => {
  const Graphic = graphicComponents[slide.graphic]

  return (
    <div
      className={`relative isolate mx-auto w-full max-w-full overflow-hidden ${compact
        ? 'h-[22svh] min-h-[140px] max-h-[200px] [@media(max-height:700px)]:h-[18svh] [@media(max-height:700px)]:min-h-[120px] [@media(max-height:700px)]:max-h-[160px]'
        : 'h-[360px] max-w-[472px]'
        }`}
      aria-hidden='true'
    >
      <Graphic compact={compact} />
    </div>
  )
}

export const AuthCarouselDesktop = () => {
  const { darkMode } = useThemeMode()
  const { currentSlide, setCurrentSlide, nextSlide, prevSlide } = useAutoPlayCarousel()

  return (
    <div
      className={cn(
        'relative flex h-full w-full flex-col items-center overflow-hidden px-10 py-10',
        darkMode ? 'bg-[#040313]' : 'bg-white',
      )}
    >
      <div
        className={cn('absolute inset-0', darkMode ? 'opacity-70' : 'opacity-100')}
        style={darkMode ? darkGridStyle : lightGridStyle}
      />
      <div className='relative flex h-full w-full flex-col items-center'>
        <div className='w-full flex-1 overflow-hidden'>
          <div
            className='flex h-full w-full transition-transform duration-500 ease-out'
            style={{
              transform: `translateX(-${currentSlide * 100}%)`,
            }}
          >
            {slides.map((slide, index) => (
              <div
                key={index}
                className='flex min-w-full flex-shrink-0 flex-col items-center justify-center'
              >
                <EditorialGraphic slide={slide} />
                <div className='mt-8 w-full max-w-[440px] space-y-3'>
                  <p
                    className={cn(
                      'text-center font-IBM text-[27px] font-bold leading-[1.12] tracking-normal',
                      darkMode ? 'text-[#f6f6f9]' : 'text-black-950',
                    )}
                  >
                    {slide.subtitle}
                  </p>
                  <p
                    className={cn(
                      'mx-auto max-w-[392px] text-center font-IBM text-sm font-medium leading-5',
                      darkMode ? 'text-[#b0b2c9]' : 'text-black-400',
                    )}
                  >
                    {slide.subtext}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className='mt-8 flex h-8 w-[192px] items-center justify-between gap-4'>
          <button
            type='button'
            className={cn(
              'flex h-8 w-8 items-center justify-center rounded-full border',
              darkMode ? 'border-white/10 bg-white/10' : 'border-black-200 bg-black-50',
            )}
            onClick={prevSlide}
          >
            <img src={left_chevron} alt='left-chevron' className={cn(!darkMode && 'invert')} />
          </button>

          <div className='flex gap-2'>
            {slides.map((_, index) => (
              <button
                key={index}
                type='button'
                className={cn(
                  'h-1 rounded-full transition-all duration-200',
                  currentSlide === index
                    ? cn('w-[18px]', darkMode ? 'bg-[#f6f6f9]' : 'bg-black-950')
                    : cn('w-1', darkMode ? 'bg-[#656992]' : 'bg-black-300'),
                )}
                onClick={() => setCurrentSlide(index)}
              ></button>
            ))}
          </div>

          <button
            type='button'
            className={cn(
              'flex h-8 w-8 items-center justify-center rounded-full border',
              darkMode ? 'border-white/10 bg-white/10' : 'border-black-200 bg-black-50',
            )}
            onClick={nextSlide}
          >
            <img src={right_chevron} alt='right-chevron' className={cn(!darkMode && 'invert')} />
          </button>
        </div>
      </div>
    </div>
  )
}

export const AuthCarouselMobile = () => {
  const { darkMode } = useThemeMode()
  const { currentSlide, setCurrentSlide, nextSlide, prevSlide } = useAutoPlayCarousel()
  const startX = useRef(0)
  const isDragging = useRef(false)

  const handleTouchStart = (e) => {
    isDragging.current = true
    startX.current = e.touches ? e.touches[0].clientX : e.clientX
  }

  const handleTouchMove = (e) => {
    if (!isDragging.current) return
    const currentX = e.touches ? e.touches[0].clientX : e.clientX
    const diff = startX.current - currentX

    if (Math.abs(diff) > 50) {
      if (diff > 0) {
        nextSlide()
      } else {
        prevSlide()
      }
      isDragging.current = false
    }
  }

  const handleTouchEnd = () => {
    isDragging.current = false
  }

  return (
    <div
      className='relative mx-auto flex h-full w-full max-w-[430px] flex-col items-center justify-end overflow-hidden bg-transparent px-1 pb-4 pt-20'
      style={{ touchAction: 'pan-y' }}
      onTouchStart={handleTouchStart}
      onTouchMove={handleTouchMove}
      onTouchEnd={handleTouchEnd}
      onMouseDown={handleTouchStart}
      onMouseMove={handleTouchMove}
      onMouseUp={handleTouchEnd}
    >
      <div className='relative flex min-h-0 w-full flex-1 flex-col justify-center overflow-hidden'>
        <div
          className='flex h-full w-full transition-transform duration-500 ease-out'
          style={{
            transform: `translateX(-${currentSlide * 100}%)`,
          }}
        >
          {slides.map((slide, index) => (
            <div
              key={index}
              className='flex min-w-full max-w-full flex-shrink-0 flex-col items-center justify-center px-5'
            >
              <EditorialGraphic slide={slide} compact />
              <p
                className={cn(
                  'mt-3 line-clamp-2 max-w-[340px] px-1 text-center font-IBM text-[16px] font-bold leading-[1.25] tracking-normal',
                  darkMode ? 'text-[#f6f6f9]' : 'text-black-950',
                )}
              >
                {slide.subtitle}
              </p>
            </div>
          ))}
        </div>
      </div>

      <div className='relative z-10 mt-2 flex h-4 w-[192px] shrink-0 items-center justify-center'>
        <div className='flex gap-2'>
          {slides.map((_, index) => (
            <button
              key={index}
              type='button'
              aria-label={`Go to slide ${index + 1}`}
              className={cn(
                'h-1 rounded-full transition-all duration-200',
                currentSlide === index
                  ? cn('w-[18px]', darkMode ? 'bg-[#f6f6f9]' : 'bg-black-950')
                  : cn('w-1', darkMode ? 'bg-[#656992]' : 'bg-black-300'),
              )}
              onClick={() => setCurrentSlide(index)}
            ></button>
          ))}
        </div>
      </div>
    </div>
  )
}
